import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { ApiResponse } from '../../../../services';
import {
  LandUseClassModel,
  LandUseClassModelFromApi,
} from './land-use-class.model';

@Injectable({
  providedIn: 'root',
})
export class LandUseClassService {
  private cache: Observable<LandUseClassModel[]>;

  constructor(private httpClient: HttpClient) {}

  get(): Observable<LandUseClassModel[]> {
    if (!this.cache) {
      this.cache = this.httpClient
        .get<
          ApiResponse<LandUseClassModelFromApi[]>
        >(`/api/interesant/wniosekDoAktuPlanowaniaPrzestrzennego/funTeren`)
        .pipe(
          map((dictionary) =>
            dictionary.Response.map((item) => LandUseClassModel.fromApi(item)),
          ),
          shareReplay(1),
        );
    }

    return this.cache;
  }
}
